import EngineController from "../../../shared/controller/EngineController.js";
import Selection from "../../../shared/js/utils/Selection.js";

export default class AcademyController extends EngineController {
	constructor(model, config, features) {
		super(model, config, features);
		this.l1SelectedFoldable = { value: {} };
		this.l1HoveredFoldable = { value: {} };
		this.panelFinders = new Selection(model.engines);

		// Set default finder items
		this.setAllFinderItemsVisible();
	}

	setAllFinderItemsVisible() {
		const finderItems = this.getFinderItemsByTypeItemIds(
			this.model.locations.map((location) => location.id),
		);

		let alternatePositions = finderItems
			.map((finderItem) =>
				finderItem.alternateX && finderItem.alternateY
					? {
							...finderItem,
							x: finderItem.alternateX,
							y: finderItem.alternateY,
						}
					: null,
			)
			.filter(Boolean);

		const groups = this.pluses.items.filter((plus) => {
			if (plus.type === "group") {
				return true;
			}
		});
		alternatePositions = alternatePositions.concat(groups);
		this.setVisibleFinderItems(alternatePositions);
	}

	panelFinderSelectAction(id) {
		this.panelFinders.selectByProperty("id", id);
		this.filterPanelItems(this.config.panel, id);
		this.setSelectedFinderImage(this.panelFinders.selection.value.image);
	}

	finderSelectAction(finder) {
		this.setSelectedFinderImage(finder.image);
	}

	setSelectedFinderImage(image) {
		this.selectedImage.value = image;
		this.markerClickAction(null, null);
	}

	setL1SelectedFoldable(foldable) {
		this.l1SelectedFoldable.value = foldable;
	}

	setL1HoveredFoldable(foldable) {
		this.l1HoveredFoldable.value = foldable;
		this.setContinentHoverStateBySvgId(foldable.svgId);
	}

	setContinentHoverStateBySvgId(svgId) {
		if (svgId) {
			const elements = document.getElementsByClassName(svgId);
			if (elements.length > 0) {
				elements[0].classList.add("hovered");
			}
		} else {
			document.querySelectorAll("g").forEach((continent) => {
				continent.classList.remove("hovered");
			});
		}
	}

	l1NavigationFoldableClickedAction(foldable, finderAction = true) {
		if (foldable.id) {
			this.setL1SelectedFoldable(foldable);

			if (finderAction) {
				this.setSelectedFinderImage(foldable.image);
				const locations = this.getLocationsByL1Id(foldable.id);
				const finderItems = this.getFinderItemsByTypeItemIds(
					locations.map((location) => location.id),
				);
				this.setVisibleFinderItems(finderItems);
			}
			//this.markersRemoveAction();
		} else {
			this.closeContinentAction();
		}

		this.setSelectedPlus({});
		this.closeNavigation();
	}

	closeContinentAction() {
		this.setL1SelectedFoldable({});
		this.setSelectedFinderImage(this.model.finderDefaultImage);
		this.setAllFinderItemsVisible();
	}

	l1NavigationFoldableHoveredAction(foldable) {
		this.setL1HoveredFoldable(foldable);
	}

	// foldable is here the navigationFoldable. Not the item
	l1IsFoldableActive(foldable) {
		for (let i = 0; i < foldable.children.length; i++) {
			if (this.isFoldableActive(foldable.children[i])) {
				return true;
			}
		}
		return false;
	}

	getLocationsByL1Id(l1Id) {
		const locations = this.model.locations.filter((location) => {
			if (location.continentId == l1Id) {
				return true;
			}
		});
		return locations;
	}

	getL1ById(id) {
		const l1 = this.model.continents.find((l1) => {
			if (l1.id == id) {
				return true;
			}
		});
		return l1;
	}

	getFinderItemsByTypeItemIds(typeItemIds) {
		const finderItems = this.pluses.items.filter((plus) => {
			if (typeItemIds.includes(plus.typeItemId)) {
				return true;
			}
		});

		return finderItems;
	}

	getLocationById(id) {
		const location = this.model.locations.find((location) => {
			if (location.id == id) {
				return true;
			}
		});
		return location;
	}

	getCountryById(id) {
		const country = this.model.countries.find((country) => {
			if (country.id == id) {
				return true;
			}
		});
		return country;
	}

	setVisibleFinderItems(finderItems) {
		this.pluses.reset();

		finderItems.forEach((finderItem) => {
			this.pluses.select(finderItem);
		});
	}

	setVisiblePlusesByFoldable(foldable) {
		// this function is defined to override engine controller function
	}

	setSelectedPlus(plus) {
		this.selectedPlus.value = plus || {};

		if (!plus) {
			this.selectedDetail.value = {};
			return;
		}

		let item;
		let country;
		if (plus.type === "plus") {
			item = this.getLocationById(plus.typeItemId);
			country = this.getCountryById(item.countryId);
			this.l1NavigationFoldableClickedAction(this.getL1ById(item.continentId));
			this.setFoldableSelected(country);
			this.setSelectedDetail(item);
		} else if (plus.type === "group") {
			item = this.getL1ById(plus.typeItemId);
			this.l1NavigationFoldableClickedAction(item);
		}
	}

	markerClickAction(marker, action) {
		if (action === "add") {
			this.categories.select(marker);
		} else if (action === "remove") {
			this.categories.deselect(marker);
		}

		const details = this.getDetailsByCategories(
			this.categories.selection.value,
		);

		let tempMarkedDetails = [];
		details.forEach((detail) => {
			tempMarkedDetails.push(detail);
		});

		if (
			this.isAContinentSelected() &&
			tempMarkedDetails.length > 0 &&
			!this.hasContinentASelectedFilter(
				this.l1SelectedFoldable.value.id,
				tempMarkedDetails,
			)
		) {
			this.closeContinentAction();
		}

		Alpine.nextTick(() => {
			Alpine.nextTick(() => {
				this.markedDetails.reset();
				this.markedPluses.reset();
				tempMarkedDetails.forEach((detail) => {
					this.markedDetails.select(detail);
					const plus = this.markedPluses.items.filter((p) => {
						if (p.type == "plus") {
							return p.typeItemId === detail.parentId;
						} else if (p.type == "group") {
							return p.groupFilterIds.includes(detail.parentId);
						}
					});
					if (plus.length > 0) {
						plus.forEach((p) => {
							this.markedPluses.select(p);
						});
					}
				});
			});
		});
	}

	isAContinentSelected() {
		return !!this.l1SelectedFoldable.value.id;
	}

	hasContinentASelectedFilter(continentId, details) {
		return !!details.find((p) => {
			return p.continentId === continentId;
		});
	}
}
